import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customers" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Customers")
], -1)
const _hoisted_4 = { class: "col-sm-6 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1)

import CustomersPagination from '@/components/customers/CustomersPagination.vue';
import CustomersList from '@/components/customers/CustomersList.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Customers',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "btn btn-lg btn-primary",
            to: "/customers/new"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" New Customer ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(CustomersPagination),
    _createVNode(CustomersList)
  ]))
}
}

})